import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  onClick: () => void;
}

const SvgClosePage: React.FC<Props> = ({ onClick }) => {
  const isRtl = useIsRtl();
  return (
    <svg
      style={isRtl ? { display: "block", transform: "scale(-1,1)" } : {}}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15637_1803)">
        <path
          d="M15.9844 3.19224C15.7766 3.19844 15.5793 3.2853 15.4344 3.43443L7.43442 11.4344C7.28444 11.5845 7.2002 11.7879 7.2002 12.0001C7.2002 12.2122 7.28444 12.4156 7.43442 12.5657L15.4344 20.5657C15.5081 20.6425 15.5964 20.7038 15.6941 20.746C15.7918 20.7882 15.897 20.8105 16.0034 20.8116C16.1098 20.8127 16.2154 20.7925 16.314 20.7523C16.4125 20.7121 16.502 20.6526 16.5773 20.5773C16.6526 20.502 16.7121 20.4125 16.7523 20.314C16.7925 20.2154 16.8127 20.1099 16.8116 20.0034C16.8105 19.897 16.7882 19.7918 16.746 19.6941C16.7037 19.5964 16.6424 19.5081 16.5657 19.4344L9.13129 12.0001L16.5657 4.56568C16.6813 4.45331 16.7602 4.30864 16.7922 4.15062C16.8242 3.99261 16.8076 3.82862 16.7448 3.68015C16.682 3.53168 16.5758 3.40566 16.4401 3.31859C16.3044 3.23153 16.1456 3.18749 15.9844 3.19224Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_15637_1803">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgClosePage;
